import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { CustomerMixStrengthLink } from 'app/core/model/customer-mix-strength-link';
import { MixStrength } from 'app/core/model/mix-strength';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-customer-mix-strength-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">{{ isNew ? 'Add' : 'Edit' }} Mix Strength</h2>
        </div>
        <div class="modal-body">
            <dx-form [formData]="customerMixStrength" validationGroup="customerMixStrengthValidationGroup">
                <dxi-item
                    dataField="mixStrengthId"
                    editorType="dxSelectBox"
                    [label]="{ text: 'Mix Strength' }"
                    [editorOptions]="{ items: mixStrengths, displayExpr: 'name', valueExpr: 'id' }"
                    [isRequired]="true"
                ></dxi-item>
                <dxi-item dataField="price" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 } }" [isRequired]="true"> </dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="save()">Save</button>
            <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
        </div>
    `,
    styles: '',
})
export class CustomerMixStrengthDialogComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    auth = inject(AuthService);
    appInfo = inject(AppInformationService);

    result = new Subject<{ success: boolean; value?: CustomerMixStrengthLink }>();
    customerMixStrength: CustomerMixStrengthLink;
    customerId: number;
    isNew: boolean;
    mixStrengths: MixStrength[];

    async ngOnInit() {
        if (!this.customerMixStrength) {
            this.isNew = true;
            this.customerMixStrength = this.uow.customerMixStrengthLinks.createEntity({
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
                customerId: this.customerId,
                price: null,
                mixStrengthId: null,
            });
        }
    }

    async save() {
        const success = this.valid();
        if (!success) return;

        await this.appInfo.pleaseWaitShow();
        await this.uow.commit([this.customerMixStrength]);
        await this.appInfo.pleaseWaitHide();

        this.result.next({ success: true, value: this.customerMixStrength });
    }

    cancel() {
        this.customerMixStrength.entityAspect.rejectChanges();

        this.result.next({ success: false });
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('customerMixStrengthValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('customerMixStrengthValidationGroup');
            return result.isValid;
        } else return false;
    }
}
